import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { loadComponentTranslations } from '../../funcs/lang-loader';

@Component({
  selector: 'app-who-can-benifit',
  imports: [TranslateModule],
  templateUrl: './who-can-benifit.component.html',
  styleUrl: './who-can-benifit.component.scss'
})
export class WhoCanBenifitComponent implements OnInit {

  professionals = [
    { icon: 'fas fa-user-tie', name: 'Business Executive' },
    { icon: 'fas fa-user-md', name: 'Doctor' },
    { icon: 'fas fa-laptop-code', name: 'Software Developer' },
    { icon: 'fas fa-chalkboard-teacher', name: 'Teacher' },
    { icon: 'fas fa-hard-hat', name: 'Engineer' },
    { icon: 'fas fa-gavel', name: 'Lawyer' },
    { icon: 'fas fa-user-nurse', name: 'Nurse' },
    { icon: 'fas fa-microscope', name: 'Scientist' },
    { icon: 'fas fa-camera-retro', name: 'Photographer' },
    { icon: 'fas fa-paint-brush', name: 'Artist' },
    { icon: 'fas fa-music', name: 'Musician' },
    { icon: 'fas fa-truck', name: 'Delivery Driver' },
    { icon: 'fas fa-cut', name: 'Hair Stylist' },
    { icon: 'fas fa-spa', name: 'Beautician' },
    { icon: 'fas fa-air-freshener', name: 'Makeup Artist' },
    { icon: 'fas fa-toolbox', name: 'Plumber' },
    { icon: 'fas fa-bolt', name: 'Electrician' },
    { icon: 'fas fa-brain', name: 'Psychiatrist' },
    { icon: 'fas fa-stethoscope', name: 'Dentist' },
    { icon: 'fas fa-briefcase-medical', name: 'Therapist' },
    { icon: 'fas fa-hotel', name: 'Hotel Manager' },
    { icon: 'fas fa-car', name: 'Car Mechanic' },
    { icon: 'fas fa-plane', name: 'Pilot' },
    { icon: 'fas fa-bus', name: 'Bus Driver' },
    { icon: 'fas fa-motorcycle', name: 'Bike Courier' },
    { icon: 'fas fa-utensils', name: 'Chef' },
    { icon: 'fas fa-coffee', name: 'Barista' },
    { icon: 'fas fa-wine-bottle', name: 'Bartender' },
    { icon: 'fas fa-store', name: 'Retail Store Owner' },
    { icon: 'fas fa-shopping-cart', name: 'E-commerce Seller' },
    { icon: 'fas fa-hand-holding-usd', name: 'Financial Advisor' },
    { icon: 'fas fa-university', name: 'Professor' },
    { icon: 'fas fa-mountain', name: 'Tour Guide' },
    { icon: 'fas fa-user-secret', name: 'Private Investigator' },
    { icon: 'fas fa-chess', name: 'Consultant' },
    { icon: 'fas fa-book', name: 'Author' },
    { icon: 'fas fa-gamepad', name: 'Game Developer' },
    { icon: 'fas fa-network-wired', name: 'IT Specialist' },
    { icon: 'fas fa-broadcast-tower', name: 'Radio Host' },
    { icon: 'fas fa-film', name: 'Filmmaker' },
    { icon: 'fas fa-theater-masks', name: 'Actor' },
    { icon: 'fas fa-wrench', name: 'Handyman' },
    { icon: 'fas fa-seedling', name: 'Gardener' },
    { icon: 'fas fa-dumbbell', name: 'Fitness Trainer' },
    { icon: 'fas fa-apple-alt', name: 'Nutritionist' },
    { icon: 'fas fa-cross', name: 'Pastor' },
    { icon: 'fas fa-pray', name: 'Spiritual Coach' },
    { icon: 'fas fa-baby', name: 'Babysitter' },
    { icon: 'fas fa-dog', name: 'Veterinarian' },
    { icon: 'fas fa-paw', name: 'Pet Groomer' },
    { icon: 'fas fa-house-user', name: 'Real Estate Agent' },
    { icon: 'fas fa-city', name: 'Architect' },
    { icon: 'fas fa-truck-moving', name: 'Moving Service Provider' },
    { icon: 'fas fa-sign-language', name: 'Interpreter' },
    { icon: 'fas fa-handshake', name: 'HR Manager' },
    { icon: 'fas fa-balance-scale', name: 'Judge' },
    { icon: 'fas fa-user-shield', name: 'Security Guard' },
    { icon: 'fas fa-drafting-compass', name: 'Interior Designer' },
    { icon: 'fas fa-star', name: 'Influencer' },
    { icon: 'fas fa-podcast', name: 'Podcaster' },
    { icon: 'fas fa-paint-roller', name: 'Painter' },
    { icon: 'fas fa-photo-video', name: 'Content Creator' },
    { icon: 'fas fa-users', name: 'Event Planner' },
    { icon: 'fas fa-shipping-fast', name: 'Logistics Manager' },
    { icon: 'fas fa-hand-holding-heart', name: 'Social Worker' },
    { icon: 'fas fa-rss', name: 'Blogger' },
    { icon: 'fas fa-comments', name: 'Customer Support Agent' },
    { icon: 'fas fa-at', name: 'Digital Marketer' },
    { icon: 'fas fa-chart-line', name: 'Stock Trader' },
    { icon: 'fas fa-warehouse', name: 'Supply Chain Manager' },
    { icon: 'fas fa-ship', name: 'Marine Engineer' },
    { icon: 'fas fa-globe', name: 'Travel Blogger' },
    { icon: 'fas fa-clinic-medical', name: 'Healthcare Consultant' },
    { icon: 'fas fa-suitcase-rolling', name: 'Flight Attendant' },
    { icon: 'fas fa-drum', name: 'DJ' },
    { icon: 'fas fa-map-marked-alt', name: 'Cartographer' },
    { icon: 'fas fa-recycle', name: 'Environmental Consultant' }
  ];


  constructor(
    private _translateService: TranslateService,
    private _http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }


  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public ngOnInit(): void {
    let lang = this._translateService.currentLang || 'en';

    this._http.get<any>('./assets/i18n/static-content/who-can-benifit-content.json')
      .subscribe({
        next: res => {
          this.professionals = res[lang]?.['profs'];
        }
      });


    loadComponentTranslations(this._http, this._translateService, 'controls/who-can-benifit', this.isBrowser())
      .subscribe({
        next: () => {

        },
        error: () => {

        }
      });
  }

}
